/** 
*@author Mustafa Omran <m.omran@MartMax.com>
*/
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './MartMax/components/home.component'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
    {
      path: 'account/auth',
      loadChildren: './MartMax/components/customers/auth/auth.module#AuthModule'
    },
  
    {
      path: 'cart',
      loadChildren: './MartMax/components/store/cart/cart.module#CartModule'
    },
  
    {
      path: 'promotions/:title',
      loadChildren: './MartMax/components/store/catalog/promotions/promotions.module#PromotionsModule'
    },
  
    {
      path: 'category/:categoryId',
      loadChildren: './MartMax/components/store/catalog/category/category.module#CategoryModule'
    },
  
    {
      path: 'search/:keywords',
      loadChildren: './MartMax/components/store/catalog/search/search.module#SearchModule'
    },
  
    {
      path: 'account/setting',
      loadChildren: './MartMax/components/customers/account-setting/account-setting.module#AccountSettingModule'
    },
  
    {
      path: 'account/new-address',
      loadChildren: './MartMax/components/customers/new-address/new-address.module#NewAddressModule'
    },
  
    {
      path: 'account/addresses',
      loadChildren: './MartMax/components/customers/address-book/address-book.module#AddressBookModule'
    },
  
    {
      path: 'account/order-summery',
      loadChildren: './MartMax/components/store/checkout/order-summery/order-summery.module#OrderSummeryModule'
    },
  
    {
      path: 'account/shipping-address',
      loadChildren: './MartMax/components/store/checkout/shipping/shipping.module#ShippingModule'
    },
  
    {
      path: 'info/brands',
      loadChildren: './MartMax/components/info/all-brands/all-brands.module#AllBrandsModule'
    },
  
    {
      path: 'info/sizechart',
      loadChildren: './MartMax/components/info/size-chart/size-chart.module#SizeChartModule'
    },
  
    {
      path: 'product/:productId',
      loadChildren: './MartMax/components/store/catalog/product/product.module#ProductModule'
    },
  
    {
      path: 'trackorder',
      loadChildren: './MartMax/components/store/checkout/trackorder/track-order.module#TrackOrderModule'
    },
  
    {
      path: 'checkout',
      loadChildren: './MartMax/components/store/checkout/logged-in-checkout/logged-in-checkout.module#LoggedInCheckoutModule'
    },
  
    {
      path: 'checkout/login',
      loadChildren: './MartMax/components/store/checkout/not-logged-in-checkout/not-logged-in-checkout.module#NotLoggedInCheckoutModule'
    },
  
    {
      path: 'products/buyforme',
      loadChildren: './MartMax/components/store/buy-for-me/buy-for-me.module#BuyForMeModule'
    },
  
    {
      path: 'products/calculator',
      loadChildren: './MartMax/components/info/calculator/calculator.module#CalculatorModule'
    },
  
    {
      path: 'info/howitworks',
      loadChildren: './MartMax/components/info/how-it-works/how-it-works.module#HowItWorksModule'
    },
  
    {
      path: 'info/contactus',
      loadChildren: './MartMax/components/info/contact-us/contact-us.module#ContactUsModule'
    },
  
    {
      path: 'info/coupons',
      loadChildren: './MartMax/components/info/coupons-history/coupons-history.module#CouponsModule'
    },
  
    {
      path: 'info/store',
      loadChildren: './MartMax/components/info/store/store.module#StoreModule'
    },
  
    {
      path: '**', component: HomeComponent
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
  
    // imports: [RouterModule.forRoot(routes)],
    // exports: [RouterModule]
  
  })
  export class AppRoutingModule { }

  


// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.routing.ts